var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cg-loader"},[_c('img',_vm._g(_vm._b({attrs:{"src":_vm.loaderUrl,"alt":""}},'img',_vm.$attrs,false),_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }